interface BundleDiscountPillModeEnvironment {
  readonly isLikeHotellovers: boolean
}

export function bundleDiscountPillModeFor(
  environment: BundleDiscountPillModeEnvironment
): 'cart' | 'hl-cart' {
  return environment.isLikeHotellovers ? 'hl-cart' : 'cart'
}
